(function () {
  'use strict';

  function updateViewAllLinks(root, trigger) {
    if (!trigger) return;

    var prefix = root.getAttribute('data-view-all-prefix') || 'Ver';
    var url = trigger.getAttribute('data-collection-url') || '#';
    var label = trigger.getAttribute('data-view-all-label') || '';
    var text = (prefix + ' ' + label).trim().toUpperCase();

    root.querySelectorAll('[data-lop-pctc-view-all]').forEach(function (link) {
      link.href = url;
      link.textContent = text;
    });
  }

  function getActiveTrigger(root) {
    return root.querySelector('.lop-pctc__tab-trigger[xo-active]:not([xo-active="false"])');
  }

  function initSection(root) {
    var triggers = root.querySelectorAll('.lop-pctc__tab-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          updateViewAllLinks(root, trigger);
        });
      });
    });

    var observer = new MutationObserver(function () {
      updateViewAllLinks(root, getActiveTrigger(root));
    });

    triggers.forEach(function (trigger) {
      observer.observe(trigger, { attributes: true, attributeFilter: ['xo-active'] });
    });

    updateViewAllLinks(root, getActiveTrigger(root));
  }

  function init() {
    document.querySelectorAll('[data-lop-pctc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lop-pctc]');
    if (root) initSection(root);
  });
})();
